<template>
  <div class="box-shadow">
  <form>
    <div class="col-sm-12">
      <h4 class="heading">Basic Details</h4>
      <div class="row">
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.firstname')}">
          <label>First Name</label><span class="message">{{ validation.firstError('formInput.firstname') }}</span>
          <input type="text" placeholder="Enter First Name Here.." class="form-control" v-model="formInput.firstname">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.lastname')}">
          <label>Last Name</label><span class="message">{{ validation.firstError('formInput.lastname') }}</span>
          <input type="text" placeholder="Enter Last Name Here.." class="form-control" v-model="formInput.lastname">
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.phone_number')}">
          <label>Phone Number (Mobile)</label><span class="message">{{ validation.firstError('formInput.phone_number') }}</span>
          <input type="text" placeholder="Enter Phone Number Here.." class="form-control" v-model="formInput.phone_number">
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.email')}">
          <label>Email Address</label><span class="message">{{ validation.firstError('formInput.email') }}</span>
          <input type="email" placeholder="Enter Email Address Here.." class="form-control" v-model="formInput.email">
        </div>  
        <div class="col-sm-4 form-group">
          <label>User Group</label>
          <select class="form-control" v-model="formInput.group_id">
            <option value="">Select User Group</option>
            <option v-for="group in user_groups" :key="group.id" :value="group.id">{{group.group_name}}</option>
          </select>
        </div>   
        <div class="form-group" :class="{error: validation.hasError('formInput.password'),'col-sm-12':formInput.action=='edit','col-sm-4':formInput.action!='edit'}">
          <span v-if="formInput.action!='edit'||resetpassword">
          <label>Password</label><span class="message">{{ validation.firstError('formInput.password') }}</span>
          <b-input-group v-if="showPassword">
            <input type="text" placeholder="Enter Password Here.." class="form-control" v-model="formInput.password">
            <template v-slot:append>
              <b-input-group-text @click="showPassword=0" title="hide password"><i class="fa fa-eye-slash" aria-hidden="true"></i></b-input-group-text>
            </template>
          </b-input-group>
          <b-input-group v-else>
            <input type="password" placeholder="Enter Password Here.." class="form-control" v-model="formInput.password">
            <template v-slot:append>
              <b-input-group-text @click="showPassword=1" title="show password"><i class="fa fa-eye" aria-hidden="true"></i></b-input-group-text>
            </template>
          </b-input-group>
          </span>
          <a href="javascript:;" @click="resetpassword=resetpassword?0:1" v-if="formInput.action=='edit'"><span v-if="resetpassword">hide </span>Reset password</a>
        </div>
      </div>
      <input type="hidden" v-model="formInput.id"/>
      <div class="" style="display:flow-root">
        <button type="button" v-on:click="addUser" class="btn btn-lg btn-info pull-right">Submit</button> 
      </div>         
    </div>
  </form>
  </div>
</template>

<script>
import axios from 'axios';
import common from '@/assets/js/common.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import SimpleVueValidator from 'simple-vue-validator';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddUserForm',
  props:['rows'],
  components: { DatePicker,VueBootstrapTypeahead },
  mixins: [common,SimpleVueValidator.mixin],
  data(){
    return {
      lessOrMore: "more",
      showPassword : 0,
      resetpassword:0,
      user_groups: {},
      formInput:{
        'id' : '',
        'action' : '',
        'firstname' : '',
        'lastname' : '',
        'phone_number' : '',
        'email' : '',
        'password' : '',
        'group_id' : '',
        'status': 1,
      }
    };
  },
  validators: {
    'formInput.firstname': function(value) {
      return Validator.value(value).required();
    },
    'formInput.lastname': function(value) {
      return Validator.value(value).required();
    },
    'formInput.phone_number': function(value) {
      return Validator.value(value);
    },
    'formInput.email': function(value) {
      return Validator.value(value).email().required();
    },
    'formInput.password': function(value) {
      if(this.resetpassword || this.formInput.action != 'edit')
        return Validator.value(value).required();
    },
  },
  watch: {
    'formInput.id': function(){
      if(this.formInput.status == 0) this.addUser();
    },
  },
  methods: {
    addUser: function(){
      this.$validate()
          .then(async (success) => {
            if (success) {
              const {response} = await this.call_axios('add_user', 'post', this.formInput);
              this.$emit('forceRerender',response);
            }
          });
    },
    async getUserGroups() {
      let uri = 'user_group_list';
      const {response} = await this.call_axios(uri);
      this.user_groups = response.data.result;
    },
  },
  mounted(){

  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
    this.getUserGroups();
  }
};
</script>

<style lang="scss" scoped>
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
</style>